/*
 * @Date: 2020-07-16 10:22:06
 * @Author: lyb
 * @LastEditors: lyb
 * @LastEditTime: 2020-07-17 11:09:44
 */
/* eslint-disable import/first */
import './util/globalVaiable.js'
import promise from 'es6-promise'
promise.polyfill()

import Vue from 'vue'
import store from './store/index'
import App from './containers/App.vue'
import VueRouter from 'vue-router'
import { routes } from './routes/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import '../css/main.less'
// import '../css/teaching.css';
// import '../css/resources.css';
import '../css/home.css'
// import '../css/outline.css';
import '../css/animate.min.css'
import '../iconfont/iconfont.css'
import '../iconfont/iconfont.js'
import { setWindowNID, setWindowNBID, formatRoute, checkIsAuth, getEnv } from './util/config'
import { SAAS_MENU, SAAS_CURRENT_MENU } from './util/keys'
import Validate from './util/filter_rules'
import VueJsonp from 'vue-jsonp'

// 引入全局过滤器
import filters from './filters/index.js'
import globalFunction from './util/globalFunction'

Vue.use(VueJsonp)
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Validate)
Vue.use(globalFunction)

const router = new VueRouter({
    routes
})

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        location.href = `https://${getEnv()}next.gaodun.com/login?redirect=https://${getEnv()}odin.gaodun.com`
        return
    }
    if (!window.SAASMENU) {
        window.SAASMENU = JSON.parse(localStorage.getItem(SAAS_MENU))
    }

    if (to.path === '/home' || to.path === '/login') {
        window.nbid = ''
        window.nid = ''
    }
    // if (to.path == '/home') {
    //     window.nid = 9;
    // }
    // console.log(window.nid, 'this is index  window.nid');
    // store.dispatch('updateCurrentSubMenu', window.nid);
    // store.dispatch('updateBreadcrumb', to.path);//更新面包屑

    setWindowNBID(window.SAASMENU, to.path) // window.nid
    checkIsAuth(window.SAASMENU, window.nbid) // 检查是否有权限
    if (!window.isAuth) {
        next({ path: '/home' })
        ElementUI.Message({
            message: '您暂未开通权限！'
        })
        return
    }
    store.dispatch('updateCurrentMenu', window.nbid)
    // if (!window.SAASCURRENTMENU) {
    window.SAASCURRENTMENU = JSON.parse(localStorage.getItem(SAAS_CURRENT_MENU))
    // }
    setWindowNID(window.SAASCURRENTMENU, to.path) // window.nid
    store.dispatch('updateCurrentSubMenu', window.nid)

    // 格式化菜单
    formatRoute(JSON.parse(localStorage.getItem(SAAS_CURRENT_MENU)), to.path)
    store.dispatch('updateBreadcrumb', to.path) // 更新面包屑

    document.title = `${to.meta.title}` || '高顿教育'
    if (!to.query.url && from.query.url) {
        to.query.url = from.query.url
    }
    setTimeout(() => {
        store.dispatch('updateCurrentTabId', to.path)
    }, 0)
    next()
})

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/js/index.js